// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-center[data-v-6dd2ceec] {\n  display: flex;\n  align-items: center;\n}\n.ml-1em[data-v-6dd2ceec] {\n  margin-left: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
